import React from "react";
import { TreeSelect as AntdTreeSelect } from "antd";

const TreeSelect = ({
	defaultValue,
	dispatch,
	name,
	questionId,
	tree,
	placeholder,
	dataType,
	isNew,
	...otherProps
}) => {
	const [answerAdded, answerEdited] = dispatch;
	const onChange = (value) => {
		let data = {
			questionId: questionId,
			value: value,
			id: name,
			dataType: dataType,
		};
		if (!isNew) answerEdited(data);
		else answerAdded(data);
	};
	return (
		<AntdTreeSelect
			treeDefaultExpandAll
			style={{ width: "100%" }}
			dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
			onChange={onChange}
			value={defaultValue}
			treeData={tree}
			placeholder={placeholder || "Search by description"}
			showSearch
			filterTreeNode={(search, item) => {
				return (
					item.title.toUpperCase().indexOf(search.toUpperCase()) >= 0
				);
			}}
			{...otherProps}
		/>
	);
};

export default TreeSelect;
